module.exports = __webpack_public_path__ + "static/img/myserver1.e6252db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/myserver1.png
// module id = ajFg
// module chunks = 2